<template>
  <Catalog
    title="Статус исполнителя"
    name-label="Название статуса"
    submit-error="Укажите название статуса исполнителя."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "WorkerStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getWorkerStatusById(id);
    },
    async putData(data) {
      return await this.putWorkerStatus(data)
    },
    async postData(data) {
      return await this.postWorkerStatus(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerStatuses/WorkerStatus.vue